// extracted by mini-css-extract-plugin
export default {"listFeatureCardCss":"ListFeatureCard_listFeatureCardCss__vNFXr"};